var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5147_21379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 0H0.833252C0.375244 0 0 0.375245 0 0.833253V10C0 10.4583 0.375244 10.8333 0.833252 10.8333H8.33325C8.7915 10.8333 9.16675 10.4583 9.16675 10V0.833253C9.16675 0.375245 8.7915 0 8.33325 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 9.16675H11.6667C11.2085 9.16675 10.8333 9.54175 10.8333 10V19.1667C10.8333 19.6248 11.2085 20 11.6667 20H19.1667C19.6247 20 20 19.6248 20 19.1667V10C20 9.54175 19.6247 9.16675 19.1667 9.16675Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 12.5H0.833252C0.375244 12.5 0 12.8752 0 13.3333V19.1667C0 19.6248 0.375244 20 0.833252 20H8.33325C8.7915 20 9.16675 19.6248 9.16675 19.1667V13.3333C9.16675 12.8752 8.7915 12.5 8.33325 12.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 0H11.6667C11.2085 0 10.8333 0.375244 10.8333 0.833252V6.66675C10.8333 7.12476 11.2085 7.5 11.6667 7.5H19.1667C19.6247 7.5 20 7.12476 20 6.66675V0.833252C20 0.375244 19.6247 0 19.1667 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5147_21379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.9bd430e5e95179eb5319e6a8957d65fc.svg";
export { ForwardRef as ReactComponent };